import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useEffect } from 'react';
import { Imposter } from '@hub/imposter';
import { Link } from '@hub/link';
import { Popover, PopoverArrow, PopoverBody, PopoverCloseButton, PopoverContent, PopoverTrigger } from '@hub/popover';
import { Text } from '@hub/text';
import { ShoppingCartMediumIcon } from '@hub/icon';
import { useToken } from '@hub/design-system-base';
import { useHistory } from 'react-router';
import { useMutation, useQuery } from '@apollo/client';
import Spinner from "@scentregroup/ui/components/spinner";
import { useDisclosure } from '@hub/use-disclosure';
import { Box } from '@hub/box';
import CartPreview from '../../../components/cart-preview-experiment';
import { useIsFirstMount } from '../../../../../apps/checkout/src/client/lib/use-is-first-mount';
import { CookieName, useCookie } from '../../../../../apps/checkout/src/client/lib/cookie';
import { GetCart } from '../../../../../apps/checkout/src/client/graphql/queries';
import MkpEmptyCart from '../../../components/cart-preview-empty';
import { UpdateCartItemQuantity } from '../../../../../apps/checkout/src/client/graphql/mutations';
import { isCartError } from '../../../../../apps/checkout/src/client/lib/on-error';
import { CHECKOUT_FULFILMENT } from '../../../../../apps/checkout/src/client/paths';
import { isICart } from '../../../../../apps/checkout/src/client/types/cart';
import { isIError } from '../../../../../apps/checkout/src/client/types/error';
import { incBase } from '../../../helpers/paths';
import trackMkpEvents, { labels } from '../../../../../apps/checkout/src/client/lib/market-place-track-event';
import { useUniversalHeaderCart } from '../../../hooks/use-cart';
import analyticsUtils from '../../../helpers/analytics-utils';
import trackClickEvent from '../../../helpers/analytics-utils/track-event';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MAX_CART_COUNT = 9;

const CartPreviewContents = () => {
  var _cart$coupons;

  const isFirstMount = useIsFirstMount();
  const history = useHistory();
  const [cartId, _setCartId, removeCartId] = useCookie(CookieName.CART);
  const [_, setCartCount, removeCartCount] = useCookie(CookieName.CART_COUNT);
  const {
    loading,
    data,
    error
  } = useQuery(GetCart, {
    context: {
      version: 2
    },
    variables: {
      id: cartId
    },
    notifyOnNetworkStatusChange: true,
    skip: !cartId,
    fetchPolicy: 'network-only',

    onError(err) {
      throw err;
    }

  });

  const handleCheckoutClick = async destination => {
    const cart = data === null || data === void 0 ? void 0 : data.cart;
    const hasStock = cart && isICart(cart) && !cart.marketplaceItems.some(marketplaceItem => marketplaceItem.quantity > marketplaceItem.variant.quantity);

    if (!hasStock) {
      trackMkpEvents.clicked(labels.CONTINUE_STOCK_ERROR);
      return;
    }

    const nextPath = CHECKOUT_FULFILMENT;

    if (destination === 'straightToCheckout') {
      history.push(nextPath);
    } else if (destination === 'viaLogin') {
      const nextRouteQuery = new URLSearchParams('');
      nextRouteQuery.append('path', nextPath);
      const queryString = nextRouteQuery.toString(); // TODO: this can be a history.push also:

      window.location.assign("".concat(incBase('/register'), "?").concat(queryString));
    }
  };

  const [updateCartItemQuantity, {
    data: updateCartItemQuantityResponse,
    loading: updateCartItemQuantityLoading,
    error: updateCartItemQuantityError
  }] = useMutation(UpdateCartItemQuantity, {
    context: {
      version: 2
    },

    onCompleted(data) {
      if (data.updateCartItemQuantity) {
        setCartCount(data.updateCartItemQuantity.marketplaceItems.reduce((a, b) => a + b.quantity, 0).toString());
      } else {
        removeCartId();
        removeCartCount();
      }
    },

    onError(err) {
      throw err;
    }

  });
  const cart = data === null || data === void 0 ? void 0 : data.cart;
  const isError = error && isCartError(error) || updateCartItemQuantityError && isCartError(updateCartItemQuantityError) || isIError(updateCartItemQuantityResponse === null || updateCartItemQuantityResponse === void 0 ? void 0 : updateCartItemQuantityResponse.updateCartItemQuantity) || // type system for some reason doesn't recognise this could only be IError even if restructured as a ternary without the negated condition
  cart && !isICart(cart) && isCartError(cart);
  useEffect(() => {
    if (isError) {
      removeCartId();
      removeCartCount();
    }
  }, [isError, removeCartId, removeCartCount]);
  useEffect(() => {
    if (isICart(cart) && cart.marketplaceItems.length === 0) {
      throw new Error("mkp cartId ".concat(cart.id, " has no marketplaceItems"));
    }
  }, [cart]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [(isFirstMount || loading || updateCartItemQuantityLoading) && /*#__PURE__*/_jsx(Spinner, {
      type: "large",
      isSeasonal: false,
      "data-id": "cart_cart-variant_CartPreviewContents_Spinner"
    }), (isError || isICart(cart) && cart.marketplaceItems.length === 0) && /*#__PURE__*/_jsx(MkpEmptyCart, {
      "data-id": "cart_cart-variant_CartPreviewContents_MkpEmptyCart"
    }), cart && isICart(cart) && cart.marketplaceItems.length && !loading && !isError && !updateCartItemQuantityLoading && /*#__PURE__*/_jsx(CartPreview, {
      id: cart.id,
      currency: cart.currency,
      cartAmount: cart.cartAmount,
      cartItems: cart.marketplaceItems,
      cartCoupons: (_cart$coupons = cart.coupons) !== null && _cart$coupons !== void 0 ? _cart$coupons : [],
      updateCartItemQuantity: updateCartItemQuantity,
      handleCheckoutClick: handleCheckoutClick,
      shippingCost: cart.shippingCost,
      standardDeliveryCost: data.marketplaceShippingConfiguration.shippingCost,
      freeShippingThreshold: data.marketplaceShippingConfiguration.freeShippingThreshold,
      "data-id": "cart_cart-variant_CartPreviewContents_CartPreview"
    })]
  });
};

export const Cart = _ref => {
  let {
    sx
  } = _ref;
  const hitTargetGrowthX = useToken('space', 'spacing-sm');
  const {
    count,
    url
  } = useUniversalHeaderCart();
  const {
    onClose,
    onOpen,
    isOpen
  } = useDisclosure();
  useEffect(() => {
    const callback = () => {
      onOpen();
    };

    window.addEventListener('sg-custom-event-open-cart-preview', callback);
    return () => {
      window.removeEventListener('sg-custom-event-open-cart-preview', callback);
    };
  });
  useEffect(() => {
    if (isOpen) {
      var _document$querySelect;

      const backdrop = document.createElement('div');
      backdrop.style.position = 'absolute';
      backdrop.style.backgroundColor = 'rgba(0, 0, 0, 0.7)';
      backdrop.style.bottom = '0px';
      backdrop.style.left = '0px';
      backdrop.style.right = '0px';
      backdrop.style.top = "".concat((_document$querySelect = document.querySelector('.chakra-tabs')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.getBoundingClientRect().bottom, "px");
      document.body.appendChild(backdrop);
      return () => {
        backdrop.remove();
      };
    }

    return () => {// no-op
    };
  }, [isOpen]);
  return /*#__PURE__*/_jsxs(Popover, {
    isLazy: true,
    isOpen: isOpen,
    trigger: 'hover',
    onClose: onClose,
    onOpen: onOpen,
    "data-id": "cart_cart-variant_CartPreviewContents_Popover",
    children: [/*#__PURE__*/_jsx(PopoverTrigger, {
      "data-id": "cart_cart-variant_CartPreviewContents_Popover_PopoverTrigger",
      children: /*#__PURE__*/_jsx(Box, {
        sx: _objectSpread({
          position: 'relative',
          top: [null, null, '-4px']
        }, sx),
        "data-id": "cart_cart-variant_CartPreviewContents_PopoverTrigger_Box",
        children: /*#__PURE__*/_jsx(Link, {
          href: url,
          sx: {
            // Increase the hit target of the button
            position: 'relative',
            display: 'flex',
            alignSelf: 'stretch',
            alignItems: 'center',
            '&:before': {
              content: '""',
              position: 'absolute',
              left: "-".concat(hitTargetGrowthX),
              right: "-".concat(hitTargetGrowthX),
              top: 0,
              bottom: 0
            }
          },
          "aria-label": "View your cart. ".concat(count === 0 ? 'No' : count, " item").concat(count === 1 ? '' : 's', "."),
          onClick: () => trackClickEvent(analyticsUtils.categories.UNIVERSAL_HEADER, analyticsUtils.actions.UNIVERSAL_HEADER_NAV_LINK_CLICK, analyticsUtils.labels.VIEW_CART),
          "data-id": "cart_cart-variant_CartPreviewContents_Box_Link",
          children: /*#__PURE__*/_jsx(Imposter, {
            constrained: false // Why aren't we using a <Label> here? Unfortuantely the requirements
            // here deviate far enough from <Label> that it ends up undoing and
            // overriding more styles than introduced by doing it manually below.
            ,
            impose: /*#__PURE__*/_jsx(Text, {
              tone: "strong",
              sx: {
                display: count === 0 ? 'none' : 'block',
                padding: '3px',
                borderRadius: '4px',
                // Ensure the padding _and_ the border take up space within the
                // box
                boxSizing: 'content-box',
                // Give the box a square-ish shape for thin numbers (eg: "1")
                minWidth: '1ch',
                // When text is thinner than '1ch', center it
                textAlign: 'center',
                border: '1px solid white',
                background: 'brand',
                color: 'white',
                // When we have "9+", make sure it doesn't wrap
                whiteSpace: 'nowrap',
                // These magic numbers come from running the desired font size
                // through Capsize: https://seek-oss.github.io/capsize/
                fontSize: '12px',
                lineHeight: '8px',
                '::before': {
                  content: "''",
                  marginBottom: '0.022em',
                  display: 'table'
                }
              },
              "data-id": "cart_cart-variant_CartPreviewContents_Text",
              children: count <= MAX_CART_COUNT ? count : "".concat(MAX_CART_COUNT, "+")
            }),
            position: "top-left",
            marginLeft: "50%",
            marginTop: "-2px",
            "data-id": "cart_cart-variant_CartPreviewContents_Link_Imposter",
            children: /*#__PURE__*/_jsx(ShoppingCartMediumIcon, {
              boxSize: "size-icon-md",
              sx: {
                verticalAlign: 'middle'
              },
              "data-id": "cart_cart-variant_CartPreviewContents_Imposter_ShoppingCartMediumIcon"
            })
          })
        })
      })
    }), /*#__PURE__*/_jsxs(PopoverContent, {
      sx: {
        border: 0,
        borderRadius: 0,
        width: 'size-3xl'
      },
      "data-id": "cart_cart-variant_CartPreviewContents_Popover_PopoverContent",
      children: [/*#__PURE__*/_jsx(PopoverArrow, {
        "data-id": "cart_cart-variant_CartPreviewContents_PopoverContent_PopoverArrow"
      }), /*#__PURE__*/_jsx(PopoverCloseButton, {
        "data-id": "cart_cart-variant_CartPreviewContents_PopoverContent_PopoverCloseButton"
      }), /*#__PURE__*/_jsx(PopoverBody, {
        sx: {
          maxHeight: '70vh',
          overflow: 'scroll',
          padding: 'spacing-none'
        },
        "data-id": "cart_cart-variant_CartPreviewContents_PopoverContent_PopoverBody",
        children: /*#__PURE__*/_jsx(CartPreviewContents, {
          "data-id": "cart_cart-variant_PopoverBody_CartPreviewContents"
        })
      })]
    })]
  });
};